<template>
  <div class="configurator-info">
    <table class="table-steps">
      <tbody>
        <tr v-for="(step, index) in steps" :key="index">
          <td>
            {{ step.name }}:
          </td>
          <td>
            <a href="#" class="step-edit">{{ step.selectedLabel }}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      steps: 'configurator/steps'
    })
  }
}
</script>
